<template>
    <div class="main">
        <div class="innerMain">
            123231123321123321123312213312213312231123321
        </div>
    </div>
</template>
<script>
export default {
  name: 'selectApp',
  data () {
    return {
    }
  },
  mounted () {
    this.$store.commit('resetMenu')
    console.log('mounted::', this.$options.name)
  },
  methods: {
  }
}
</script>

<style scoped>
.main {
   width: 100%;
   height: 100%;
   color:#e0e0e0;
   min-width:400px;
   margin:auto;
  }
  .innerMain{
    width:100%;
    height: -moz-calc(100vh - 100px);
    height:-webkit-calc(100vh - 100px);
    height:calc(100vh - 100px);
    display: inline-block;
  }
</style>



// WEBPACK FOOTER //
// src/components/selectApp/selectApp.vue